module.exports = __webpack_public_path__ + "static/media/chien_jouet.409e62a3.png";